import * as yup from 'yup';

export const patientFormsValidationSchema = yup
  .object()
  .shape({
    phone: yup
      .string()
      .nullable()
      // no more than 10 digits
      .test(
        'max-10-digits',
        'Phone number cannot exceed 10 digits',
        value => !value || (value?.replace(/\D/g, '').length || 0) <= 10
      )
      .test(
        'min-10-digits',
        'Phone number must be at least 10 digits',
        value => !value || (value?.replace(/\D/g, '').length || 0) >= 10
      ),

    email1: yup
      .string()
      .test(
        'at-least-one-email',
        'Please enter at least one email address',
        function(value) {
          const { email2, email3 } = this.parent || {};
          const e1 = value || '';
          const e2 = email2 || '';
          const e3 = email3 || '';
          return e1.trim().length > 0 || e2.trim().length > 0 || e3.trim().length > 0;
        }
      )
      .test(
        'valid-email1',
        'Must be a valid email address',
        value => !value || yup.string().email().isValidSync(value)
      ),
    email2: yup
      .string()
      .nullable()
      .test(
        'conditional-email2',
        'Must be a valid email address',
        value => !value || yup.string().email().isValidSync(value)
      ),
    email3: yup
      .string()
      .nullable()
      .test(
        'conditional-email3',
        'Must be a valid email address',
        value => !value || yup.string().email().isValidSync(value)
      ),
    patient_name: yup
      .string()
      .required("Patient's Name is required")
      .trim(),
    mrn: yup
      .string()
      .required("Patient's MRN is required")
      .trim(),
    dob: yup
      .string()
      .required("Patient's DOB is required")
      .trim(),
    hospital_number: yup
      .string()
      .nullable()
      .trim(),
  })